import { useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";

export const useGlobalSearch = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const search = async (value) => {
    if (!value || value.length < 2) {
      setResults([]);
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.get(`${apiurl}/api/cst/search`, {
        params: { q: value, limit: 10 },
      });

      if (data.success) setResults(data.data);
    } catch (err) {
      console.error("Search failed", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    query,
    setQuery,
    results,
    loading,
    search,
  };
};